import React from 'react'
import {getBattleArenaMenuData} from './getSubmissionMenuData.js'
import Menu from '../../../menu-engine'
import {setBattleValue} from '../../../redux-actions/battle-actions.js'


class ArenaMenuBrain extends React.Component {

  componentWillMount() {

    //console.log('>>>>>>>>>>>>>>', 'brain componentWillMount')

    //Set up the brain.
    this.menuModel = new Menu(getBattleArenaMenuData(), "homeView");
    const initialSnapshot = this.menuModel.init();
    // console.log('client initial snapshot', initialSnapshot);

    setBattleValue({
      arenaMenuSnapshot: { ...initialSnapshot}
    });

    //Listen for changes
    this.menuModel.listen(newSnapshot => {
      setBattleValue({
        arenaMenuSnapshot: { ...newSnapshot}
      })
    });
  }

  // componentWillUpdate(newProps) {
  //   if (newProps.rolloutId !== this.props.rolloutId) {
  //     console.log('need to reset the brain!')
  //     //This happens too early...
  //   }
  // }

  componentWillUnmount() {
    //Unmount the brain
    setTimeout(() => {
      //For some reason, ENTER key fires before this, but CLICKS do not. Wait a bit before unmounting.
      //Rethinking how the brain comes in and out should solve this, I think. Maybe not.

      // console.log('unmounting the brain');
      this.menuModel.destroy();
      delete this.menuModel;
    }, 50)
  }

  render() {
    //I'm the bindings and stuff for the Menu Model
    //I don't have any DOM elements
    return null
  }
}

export default ArenaMenuBrain;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/ArenaMenuBrain.js